import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFeedbackMobApp, TError } from './types/FeedbackMobApp-interface';
import { fetchFeedbackMobApp } from './action/fetch-feedback-mob-app';

const initialState: IFeedbackMobApp = {
    Name: '',
    Phone: '',
    BirthDate: '',
    Email: '',
    Theme: '',
    Description: '',
    isLoading: false,
    error: '',
    errorCode: 99,
    result: false,
};

export const FeedbackMobAppSlice = createSlice({
    name: 'FeedbackMobAppSlice',
    initialState,
    reducers: {
        updateField: (state, action: PayloadAction<{ field: keyof IFeedbackMobApp; value: IFeedbackMobApp[keyof IFeedbackMobApp] }>) => {
            const { field, value } = action.payload;
            state[field] = value as never;
        },
        resetForm: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFeedbackMobApp.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchFeedbackMobApp.fulfilled, (state, action: PayloadAction<{ result: number }>) => {
                state.isLoading = false;
                state.error = '';
                state.errorCode = action.payload.result;
            })
            .addCase(fetchFeedbackMobApp.rejected, (state, action) => {
                if (action.payload) {
                    const { Error, Message } = action.payload as { Error: number; Message: string };
                    state.isLoading = false;
                    state.error = Message;
                    state.errorCode = Error;
                    state.result = false;
                }
            });
    },
});

export const { updateField } = FeedbackMobAppSlice.actions;
export default FeedbackMobAppSlice.reducer;
